import { ConfigProvider, Table as AntdTable } from 'antd';
import { getColumns } from './getColumns';

export const Table = ({ records, loading }) => {
  const columns = getColumns();

  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 14,
          colorBorderSecondary: '#f0f0f0',
        },
        components: {
          Table: {
            headerBg: '#ffffff',
            headerColor: '#000000',
            headerSplitColor: 'transparent',
            rowHoverBg: '#fafafa',
            cellPaddingBlock: 16,
            cellPaddingInline: 16,
          },
        },
      }}
    >
      <AntdTable
        rowKey='id'
        columns={columns}
        dataSource={records}
        loading={loading}
        size='middle'

        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: false,
        }}
        style={{ border: '1px solid #f0f0f0', borderRadius: 8 }}
      />
    </ConfigProvider>
  );
};